import Vue from 'vue';
import Loading from './index.vue';
const loading = Vue.extend(Loading); // 创建的是一个组件构造器，不是实例
const LoadingInstance = (options) => {
  let instance = new loading({
    data: {
      ...options
    }
  }).$mount();
  document.body.appendChild(instance.$el); // 添加dom元素
  return instance;
};
Vue.prototype.$loading = LoadingInstance;
export default LoadingInstance;
